export const solutions = [
    {
        number: "01",
        title: "End User Computing",
        para: [
            {
                subheading: "Laptops, Desktops, Workstations",
                description:
                    "High-performance devices designed to handle everyday business tasks, creative workflows, and compute-intensive workloads with reliability and speed.",
            },
            {
                subheading: "Thin Clients & Rugged Machines",
                description:
                    "Lightweight, energy-efficient thin clients for centralized computing, and rugged machines built to withstand extreme environments and heavy-duty usage.",
            },
            {
                subheading: "VDI & BYOD Solutions",
                description:
                    "Virtual Desktop Infrastructure and Bring Your Own Device solutions to enable secure, flexible, and remote work without compromising productivity.",
            },
        ],
    },
    {
        number: "02",
        title: "Server, Storage & Backup",
        para: [
            {
                subheading: "Servers: Rack, Tower, Converged Infrastructure",
                description:
                    "Scalable server solutions for every business need, from compact towers to high-density racks and converged systems for integrated computing power.",
            },
            {
                subheading: "Storage: SAN/NAS, DAS, Unified Storage",
                description:
                    "Enterprise-grade storage systems offering high availability, rapid access, and robust data management for critical workloads.",
            },
            {
                subheading: "Backup & Disaster Recovery Solutions",
                description:
                    "Comprehensive data protection strategies to safeguard against loss, ensure business continuity, and enable quick recovery in any disaster scenario.",
            },
        ],
    },
    {
        number: "03",
        title: "Networking",
        para: [
            {
                subheading: "Enterprise Routing & Switching",
                description:
                    "High-performance routing and switching solutions that deliver low-latency connectivity, seamless scalability, and robust network management.",
            },
            {
                subheading: "Wireless & Mobility Solutions",
                description:
                    "Reliable wireless networks designed to support high user density, mobility, and seamless connectivity across your enterprise.",
            },
            {
                subheading: "Network Optimization & Security",
                description:
                    "Tools and services to boost network efficiency, reduce downtime, and protect against cyber threats with next-gen security protocols.",
            },
        ],
    },
    {
        number: "04",
        title: "UPS / Racks / Power Solutions",
        para: [
            {
                subheading: "UPS Systems & Cooling",
                description:
                    "Uninterrupted power supply systems coupled with advanced cooling solutions to protect critical equipment from outages and overheating.",
            },
            {
                subheading: "Power Distribution Units (PDUs)",
                description:
                    "Intelligent PDUs that deliver reliable power distribution, remote monitoring, and energy optimization for your IT infrastructure.",
            },
            {
                subheading: "Racks & Enclosures",
                description:
                    "Secure, space-efficient racks and enclosures designed to house and protect servers, networking gear, and other essential equipment.",
            },
        ],
    },
];
